import { Person, PersonFilters } from '@/analysis/types';
import { QueryResult } from '@/type';
import api from '@/API';

export default {
  findAll(clientId: number, filters: PersonFilters = {}): Promise<QueryResult<Person>> {
    return api
      .get(`clients/${clientId}/persons`, { params: filters })
      .then(response => response.data);
  },

};
